export const getImageMimeType = (source) => {
  if (!source) return null;

  const fmMatch = source.match(/fm=([a-z]+)/i);
  const format =
    fmMatch && fmMatch[1]
      ? fmMatch[1].toLowerCase()
      : source.split('.').pop().toLowerCase();

  switch (format) {
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    case 'webp':
      return 'image/webp';
    case 'avif':
      return 'image/avif';
    case 'svg':
      return 'image/svg+xml';
    case 'gif':
      return 'image/gif';
    case 'ico':
      return 'image/x-icon';
    default:
      return 'image/jpeg';
  }
};

export function getPreloadCandidatesFromSrcSet(srcSet) {
  if (!srcSet) return {};

  const sources = srcSet.split(',').map(entry => {
    const [url, width] = entry.trim().split(' ');
    return {
      src: url,
      width: parseInt(width.replace('w', ''), 10),
    };
  });

  // Sort by width ascending
  const sorted = sources.sort((a, b) => a.width - b.width);

  // Now match exact values if available
  const mobile = sources.find(s => s.width === 768) || sorted[0];
  const tablet = sources.find(s => s.width >= 1024 && s.width <= 1440);
  const desktop = sources.find(s => s.width === 1920) || sorted.at(-1);

  return { mobile, tablet, desktop };
}



